var $=jQuery;
jQuery(document).ready(function ($) {
  /*** PDD SLIDER ***/
  var product_custom = document.querySelectorAll('.product-slider .product-grid li');
  if (product_custom.length > 4) {
    product_custom.forEach(function(product_item) {
      var product_slider = product_item.closest('.product-slider .product-grid');
      if (product_slider) {
        var flkty = new Flickity(product_slider, {
           pageDots: false,
          cellAlign: 'left',
          groupCells: true,
          wrapAround: true,
          autoPlay: false,
          prevNextButtons: false,
          freeScroll: true, 
        });
      }
    });
  }
  var product_custom = document.querySelectorAll('.product-slider .product-grid li');
    if (product_custom.length > 4) {
      product_custom.forEach(function(product_item) {
        var product_slider = product_item.closest('.product-slider .product-grid');
        if (product_slider) {
          var flkty = new Flickity(product_slider, {
             pageDots: false,
            cellAlign: 'left',
            groupCells: true,
            wrapAround: true,
            autoPlay: false,
            prevNextButtons: true,
            freeScroll: true, 
          });
        }
      });
    }

  // Get the gallery items
  var $gallery = $('.product-single__gallery');
  var galleryItems = $gallery.find('.product-single__gallery-item').length;
  
  // Only initialize Flickity if there's more than one item
  if (galleryItems > 1) {
    $gallery.flickity({
      imagesLoaded: true,
      groupCells: false,
      dragThreshold: 5,
      cellAlign: 'center',
      wrapAround: true,
      prevNextButtons: true,
      percentPosition: true, 
      pageDots: false,
      rightToLeft: false,
      autoPlay: false,
      sync: '.product-single__thumbnails'
    });
}

  $('.product-single__gallery').on('change.flickity', function(event, index) {
      var $thumbnails = $('.product-single__thumbnails li');
      $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
      $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
  });
  $('.product-single__thumbnails li').first().addClass('active');

  // Thumbnail click event to change the gallery image
  $('.product-single__thumbnails li').on('click', function() {
      var index = $(this).index();
      $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
  });

  document.addEventListener("DOMContentLoaded", function() {
      const thumbsScroller = document.querySelector(".product-single__thumbnails");
      const btnPrev = document.querySelector("button.product__thumb-arrow.product__thumb-arrow--prev");
      const btnNext = document.querySelector("button.product__thumb-arrow.product__thumb-arrow--next");
      const scrollStep = 100; 
      const scrolledClass = "scrolled-end";
      // const extraItemsClass = "has-extra-items";
      // const minItems = 6; 
      // const items = thumbsScroller ? thumbsScroller.children : [];
  
      let hasScrolled = false; 
  
      function updateButtonState() {
        const isAtTop = thumbsScroller.scrollTop === 0;
    
        const threshold = 5; 
        const isAtBottom =
            thumbsScroller.scrollTop + thumbsScroller.clientHeight >= thumbsScroller.scrollHeight - threshold;
    
        btnPrev.disabled = isAtTop;
        btnNext.disabled = isAtBottom;
    
        if (hasScrolled && isAtBottom) {
            thumbsScroller.classList.add(scrolledClass);
        } else {
            thumbsScroller.classList.remove(scrolledClass);
        }
      }
  
  
      // function addExtraItemsClass() {
      //     if (items.length > minItems) {
      //         thumbsScroller.classList.add(extraItemsClass);
      //     } else {
      //         thumbsScroller.classList.remove(extraItemsClass);
      //     }
      // }
  
      if (thumbsScroller) {
          btnPrev.addEventListener("click", () => {
              thumbsScroller.scrollBy({ top: -scrollStep, behavior: "smooth" });
          });
  
          btnNext.addEventListener("click", () => {
              thumbsScroller.scrollBy({ top: scrollStep, behavior: "smooth" });
          });
  
          thumbsScroller.addEventListener("scroll", () => {
              hasScrolled = true; 
              updateButtonState();
          });
  
          //addExtraItemsClass();
          updateButtonState();
        }
    });
});